module.exports = __webpack_public_path__ + "static/img/icon_applepay.02e0cbee.png";